export interface WaterTypeOption {
  value: string;
  label: string;
}

export const WATER_TYPES: WaterTypeOption[] = [
  { value: "agua_residual", label: "Agua Residual" },
  { value: "agua_en_proceso", label: "Agua en Proceso" },
  { value: "agua_biosolidos", label: "Agua de Biosólidos" },
];

export const getWaterTypeLabel = (value: string): string =>
  WATER_TYPES.find((t) => t.value === value)?.label ?? value;

// A vehicle's effective water types: the per-vehicle stored subset
// (`truck_yard_types`) intersected against the group-inherited pool. Mirrors
// the rule used across the access/vehicles sections so a type dropped from a
// group disappears here too. When the subset is unset, or the intersection
// collapses to empty, we fall back to the inherited list to preserve the
// "never empty" invariant.
export function effectiveWaterTypes(
  perVehicleSubset: string[] | undefined | null,
  inherited: string[],
): string[] {
  if (!Array.isArray(perVehicleSubset)) return inherited;
  const filtered = perVehicleSubset.filter((t) => inherited.includes(t));
  return filtered.length > 0 ? filtered : inherited;
}
